export const mouseInteractivity_PopUp = 'pop-up';
export const mouseInteractivity_ToolTip = 'tool-tip';
//# sourceMappingURL=types.js.map